// extracted by mini-css-extract-plugin
module.exports = {"link":"LinkComponent_link__3KF1A","icon":"LinkComponent_icon__-Pvk4"};